/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useSearchAutocompleteStyles = makeStyles({
  formControl: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: '28px',
    '& .MuiFormHelperText-root': {
      fontSize: '12px',
      lineHeight: '16px',
      padding: '0 16px',
      '&.Mui-error': {
        color: '#FA634E',
      },
    },
  },
  searchWrapper: {
    flex: '0 0 420px',
  },
});
